import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

const SelectField = ({
        name,
        value,
        id,
        label,
        error,
        info,
        onChange,
        disabled,
        options,
        required,
}) => {

    const selectOptions = options.map(option => (
        <option key={option.key} value={option.id}>{option.name}</option>
    ));

  return (
    <div className="form-group">
        {label && (
          <label className='form-label'>{label}{required && <span className="text-danger ms-1">*</span>}</label>
        )}
        <select className={classnames('form-select', {'is-invalid' : error})} id={id} name={name} value={value} onChange={onChange} disabled={disabled}>{selectOptions}</select>
        {info && <small className='form-text text-muted'>{info}</small>}
        {error && <div className="invalid-feedback mb-2" style={{textAlign: 'left'}}>{error}</div>}
    </div>
  )
}

SelectField.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]).isRequired,
    label: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    error: PropTypes.string,
    info: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.string,
    options: PropTypes.array.isRequired
}

SelectField.defaultProps = {
    type: 'text'
}

export default SelectField
